import { render, staticRenderFns } from "./subscriptionManage.vue?vue&type=template&id=52640952&scoped=true"
import script from "./subscriptionManage.vue?vue&type=script&lang=js"
export * from "./subscriptionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52640952",
  null
  
)

export default component.exports